import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap'

export default class extends Controller {
  static targets = ['deleteModal', 'deleteSeriesName']

  connect() {
    this.deleteUrl = ''
    this.seriesName = ''
    this.rowToDelete = null
    this.deleteModal = new bootstrap.Modal(this.deleteModalTarget)
  }

  showDeleteModal(event) {
    event.preventDefault()

    const deleteUrl = event.currentTarget.dataset.deleteUrl
    const seriesName = event.currentTarget.dataset.seriesName
    
    this.deleteUrl = deleteUrl
    this.seriesName = seriesName
    
    // Set series name in modal
    this.deleteSeriesNameTarget.textContent = seriesName
    
    // Show confirmation modal
    this.deleteModal.show()
  }

  confirmDelete() {
    // Hide confirmation modal
    this.deleteModal.hide()
    
    // Check if TOTP verification is needed
    const currentAdminHasTotp = this.element.dataset.currentAdminTotpEnabled === 'true'
    
    if (currentAdminHasTotp) {
      this.showTotpModal()
    } else {
      this.sendDeleteRequest()
    }
  }

  sendDeleteRequest() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    
    fetch(this.deleteUrl, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (response.ok) {
        // Redirect to series index
        window.location.href = '/series'
      } else {
        throw new Error('Delete failed')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert(error.message || 'Delete failed')
    })
  }

  showTotpModal() {
    // Dispatch custom event to reusable TOTP modal
    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: this.deleteUrl,
        actionMethod: 'DELETE',
        formData: {},
        rowToDelete: this.rowToDelete,
        dataTable: null,
        redirectUrl: '/series'
      }
    })
    document.dispatchEvent(event)
  }
} 